import { useState } from "react";

import { useNavigate } from "react-router-dom";
// @mui
import { alpha } from "@mui/material/styles";
import {
  Box,
  Divider,
  Typography,
  MenuItem,
  Avatar,
  IconButton,
  Popover,
} from "@mui/material";
// mocks_
import account from "../../../_mock/account";

import { useStore } from "../../../App";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const navigate = useNavigate();

  const handleLogout = () => {
    useStore.setState({ userStatus: false });
    useStore.setState({ accessToken: null });
    useStore.setState({ refreshToken: null });
    navigate("/");
  };

  return (
    <div style={{ fontFamily: "Neo Sans Regular" }}>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={account.photoURL} alt="photoURL" />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            "& .MuiMenuItem-root": {
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5, fontFamily: "Neo Sans Regular" }}>
          <Typography
            variant="subtitle2"
            noWrap
            style={{ fontFamily: "Neo Sans Regular" }}
          >
            {account.displayName}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {account.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: "solid", borderColor: "#0" }} />

        <Divider sx={{ borderStyle: "solid", borderColor: "#025642" }} />

        <MenuItem
          onClick={handleLogout}
          sx={{ m: 1, fontFamily: "Neo Sans Medium" }}
        >
          Log Out
        </MenuItem>
      </Popover>
    </div>
  );
}
